import { styled } from '@mui/material/styles';

import { SidebarStateKey } from 'applications/GSP/layouts/MainLayout/components/Sidebar/store';
import {
  closedMixin,
  openedMixin,
} from 'applications/GSP/layouts/MainLayout/components/Sidebar/utils';
import { Avatar as SharedAvatar } from 'shared/components/Avatar';

import { GRID_AREA_STUDENT_AVATAR } from './constants';

import type { SidebarAnimatedComponentsState } from 'applications/GSP/layouts/MainLayout/components/Sidebar/types';

const avatarSize = 40;

export const StudentAvatar = styled(SharedAvatar, {
  shouldForwardProp: prop => prop !== SidebarStateKey.Opened,
})<SidebarAnimatedComponentsState>(({ theme, opened }) => ({
  width: avatarSize,
  height: avatarSize,
  gridArea: GRID_AREA_STUDENT_AVATAR,
  backgroundColor: theme.palette.primary.main,
  ...(opened && {
    ...openedMixin({ theme }),
  }),
  ...(!opened && {
    ...closedMixin({ theme }),
  }),
}));
